import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect } from 'react';
import { useCalculatorContext, useProductContext } from '../../../contexts';
import { getValue, setValue } from '../../../utils';
import { AlertControlUi } from '../AlertControl';
import { ArrayControlUi } from '../ArrayControl';
import { CarouselControlUi } from '../CarouselControl';
import { CONTROL } from '../constants';
import { ObjectControlUi } from '../ObjectControl';
import { SegmentedControlUi } from '../SegmentedControl';
import { SelectMultipleUi, SelectSingleUi } from '../SelectControl';
import { SliderControlUi } from '../SliderControl';
import { StepperControlUi } from '../StepperControl';
import { TableControlUi } from '../TableControl';
import { ToggleCardsControlUi } from '../ToggleCardsControl';
import { ToggleControlUi } from '../ToggleControl';
import { ToggleObjectControlUi } from '../ToggleObjectControl';
import { jsx as _jsx } from "react/jsx-runtime";
export function Control(_ref) {
  var _formControl$accessor, _Object$keys, _formControl$watchedC;
  var formControl = _ref.formControl;
  var _useCalculatorContext = useCalculatorContext(),
    calculatorType = _useCalculatorContext.calculatorType;
  var _useProductContext = useProductContext(),
    valueProp = _useProductContext.value,
    onChangeProp = _useProductContext.onChange,
    priceListProp = _useProductContext.priceList;
  var _useCalculatorContext2 = useCalculatorContext(),
    pricePeriod = _useCalculatorContext2.pricePeriod,
    setPricePeriod = _useCalculatorContext2.setPricePeriod;
  var accessorKey = (_formControl$accessor = formControl === null || formControl === void 0 ? void 0 : formControl.accessorKey) !== null && _formControl$accessor !== void 0 ? _formControl$accessor : '';
  useEffect(function () {
    var _formControl$onChange;
    var setValueFn = function setValueFn(arr) {
      arr.forEach(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          accessorKey = _ref3[0],
          newValue = _ref3[1];
        setValue(valueProp, accessorKey, newValue);
      });
      onChangeProp(valueProp);
    };

    // Если в разных продуктах есть поля с одинаковыми названиями ключа,
    // то в formControl может возникнуть конфликт с определением и изменением значений этих полей.
    // Попробуйте поменять название поля на другое уникальное значение.

    formControl === null || formControl === void 0 ? void 0 : (_formControl$onChange = formControl.onChangePeriod) === null || _formControl$onChange === void 0 ? void 0 : _formControl$onChange.call(formControl, pricePeriod, setValueFn);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pricePeriod]);
  var watchedValues = (_Object$keys = Object.keys((_formControl$watchedC = formControl === null || formControl === void 0 ? void 0 : formControl.watchedControls) !== null && _formControl$watchedC !== void 0 ? _formControl$watchedC : {})) === null || _Object$keys === void 0 ? void 0 : _Object$keys.reduce(function (res, fieldName) {
    var _formControl$watchedC2;
    var key = formControl === null || formControl === void 0 ? void 0 : (_formControl$watchedC2 = formControl.watchedControls) === null || _formControl$watchedC2 === void 0 ? void 0 : _formControl$watchedC2[fieldName];
    if (key) {
      res[fieldName] = getValue(valueProp, key);
    }
    return res;
  }, {});
  watchedValues.calculatorType = calculatorType;
  if (formControl.type === CONTROL.Object) {
    return /*#__PURE__*/_jsx(ObjectControlUi, _objectSpread(_objectSpread({}, formControl), {}, {
      watchedValues: watchedValues
    }));
  }
  if (formControl.type === CONTROL.Array) {
    return /*#__PURE__*/_jsx(ArrayControlUi, _objectSpread({}, formControl));
  }
  var value = getValue(valueProp, accessorKey);
  var priceList = getValue(priceListProp, accessorKey);
  var onChange = function onChange(newValue) {
    if (formControl !== null && formControl !== void 0 && formControl.canChangeWholePricePeriod) {
      setPricePeriod(newValue);
    }
    setValue(valueProp, accessorKey, newValue);
    onChangeProp(valueProp);
  };
  if (formControl !== null && formControl !== void 0 && formControl.onChangeFn) {
    var setValueFn = function setValueFn(arr) {
      arr.forEach(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          accessorKey = _ref5[0],
          newValue = _ref5[1];
        setValue(valueProp, accessorKey, newValue);
      });
      onChangeProp(valueProp);
    };
    onChange = function onChange(newValue) {
      var _formControl$onChange2;
      formControl === null || formControl === void 0 ? void 0 : (_formControl$onChange2 = formControl.onChangeFn) === null || _formControl$onChange2 === void 0 ? void 0 : _formControl$onChange2.call(formControl, newValue, setValueFn);
    };
  }
  switch (formControl.type) {
    case CONTROL.Table:
      {
        return /*#__PURE__*/_jsx(TableControlUi, _objectSpread(_objectSpread({}, formControl), {}, {
          value: value,
          onChange: onChange,
          priceList: priceList
        }));
      }
    case CONTROL.Carousel:
      {
        return /*#__PURE__*/_jsx(CarouselControlUi, _objectSpread(_objectSpread({}, formControl), {}, {
          value: value,
          onChange: onChange,
          watchedValues: watchedValues
        }));
      }
    case CONTROL.ToggleCards:
      {
        return /*#__PURE__*/_jsx(ToggleCardsControlUi, _objectSpread(_objectSpread({}, formControl), {}, {
          value: value,
          onChange: onChange,
          watchedValues: watchedValues
        }));
      }
    case CONTROL.SelectSingle:
      {
        return /*#__PURE__*/_jsx(SelectSingleUi, _objectSpread(_objectSpread({}, formControl), {}, {
          value: value,
          onChange: onChange,
          watchedValues: watchedValues
        }));
      }
    case CONTROL.SelectMultiple:
      {
        return /*#__PURE__*/_jsx(SelectMultipleUi, _objectSpread(_objectSpread({}, formControl), {}, {
          value: value,
          onChange: onChange,
          watchedValues: watchedValues
        }));
      }
    case CONTROL.Segmented:
      {
        return /*#__PURE__*/_jsx(SegmentedControlUi, _objectSpread(_objectSpread({}, formControl), {}, {
          value: value,
          onChange: onChange,
          watchedValues: watchedValues
        }));
      }
    case CONTROL.Toggle:
      {
        return /*#__PURE__*/_jsx(ToggleControlUi, _objectSpread(_objectSpread({}, formControl), {}, {
          value: value,
          onChange: onChange,
          watchedValues: watchedValues
        }));
      }
    case CONTROL.Stepper:
      {
        return /*#__PURE__*/_jsx(StepperControlUi, _objectSpread(_objectSpread({}, formControl), {}, {
          value: value,
          onChange: onChange,
          watchedValues: watchedValues
        }));
      }
    case CONTROL.ToggleObject:
      {
        return /*#__PURE__*/_jsx(ToggleObjectControlUi, _objectSpread(_objectSpread({}, formControl), {}, {
          value: value,
          onChange: onChange,
          watchedValues: watchedValues
        }));
      }
    case CONTROL.Alert:
      {
        return /*#__PURE__*/_jsx(AlertControlUi, _objectSpread(_objectSpread({}, formControl), {}, {
          watchedValues: watchedValues
        }));
      }
    case CONTROL.Slider:
      {
        return /*#__PURE__*/_jsx(SliderControlUi, _objectSpread(_objectSpread({}, formControl), {}, {
          value: value,
          onChange: onChange,
          watchedValues: watchedValues
        }));
      }
    default:
      throw new Error('not reachable');
  }
}